<template>
    <t-section
      v-bind:schemaName="'contact'"
      v-bind:fields="fields"
      v-bind:headers="headers"
      v-bind:isHideChart="true"
    >
        <template v-slot:custom="{ close }">
            <sender-detail v-on:sent="close" />
        </template>
        <template v-slot:cell="{ row, header, value }">
            <span
              v-if="isStatusColumn(header)"
              class="contact-status-chip"
              v-bind:class="getStatusClass(row)"
            >
                {{ value }}
            </span>
            <template v-else>
                {{ value }}
            </template>
        </template>
    </t-section>
</template>

<script>
import SenderDetail from "@/views/details/messages/SenderDetail.vue";
import TSection from '@/components/Sections/SectionV3.vue';
export default {
    name: "SectionContact",
    components: {
        TSection,
        SenderDetail
    },
    methods: {
        async loadLookups() {
            const response = await this.$store.dispatch('section', { table: "contactStatus", body: {} })
            this.lookups.status = response.data.data ?? [];
        },
        isStatusColumn(header) {
            return header.field === "status.name";
        },
        getStatusId(row) {
            return row?.statusId || row?.status?.id;
        },
        getStatusClass(row) {
            switch (this.getStatusId(row)) {
                case "1bf61851-347c-4d0d-a62e-d488dce9c0da":
                    return "contact-status-chip--approved";
                case "2bf61851-347c-4d0d-a62e-d488dce9c0da":
                    return "contact-status-chip--canceled";
                case "3bf61851-347c-4d0d-a62e-d488dce9c0da":
                    return "contact-status-chip--review";
                case "4bf61851-347c-4d0d-a62e-d488dce9c0da":
                    return "contact-status-chip--dismissed";
                default:
                    return "contact-status-chip--default";
            }
        },
    },
    computed: {
        fields: {
            get() {
                return [
                    { field: "statusId", name: "Статус", type: "lookup", lookup: this.lookups.status },
                    { field: "mobilePhone", name: this.$filters.localize("ContactPage.fields.mobilePhone"), type: "string" },
                    { field: "surname", name: this.$filters.localize("ContactPage.fields.fullName"), type: "string" },
                    { field: "code", name: this.$filters.localize("ContactPage.fields.code"), type: "string" }
                ]
            }
        }
    },
    data() {
        return {
            lookups: {
                status: []
            },
            headers: [
                { field: "surname", name: this.$filters.localize("ContactPage.fields.surname"), sort: true, router: { field: "id", name: "ContactPage" } },
                { field: "name", name: this.$filters.localize("ContactPage.fields.name"), sort: true, router: { field: "id", name: "ContactPage" } },
                { field: "mobilePhone", name: this.$filters.localize("ContactPage.fields.mobilePhone"), sort: true, filter: true, router: { field: "id", name: "ContactPage" } },
                { field: "status.name", name: "Статус", sort: true, filter: true, config: { field: "statusId", type: "status" }, router: { field: "id", name: "ContactPage" } }
            ],
        }
    },
    async mounted() {
        await this.loadLookups();
    }
}
</script>

<style scoped>
.contact-status-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    min-height: 26px;
    padding: 4px 10px;
    border: 1px solid transparent;
    border-radius: 999px;
    font-size: inherit;
    font-weight: 400;
    line-height: 1.15;
    white-space: nowrap;
}

.contact-status-chip--approved {
    border-color: #8fd89f;
    color: #0f7a3a;
    background: #f0fdf4;
}

.contact-status-chip--canceled,
.contact-status-chip--dismissed {
    border-color: #f0a8a0;
    color: #b42318;
    background: #fff8f7;
}

.contact-status-chip--review {
    border-color: #f5c46b;
    color: #8a5a00;
    background: #fff7df;
}

.contact-status-chip--default {
    border-color: #d9e2ec;
    color: #526171;
    background: #f7fafc;
}
</style>
